(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[84141,65250],{

/***/ 84141:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ SteelBuildingEstimatesWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/components/shared/header/index.tsx
var header = __webpack_require__(74206);
// EXTERNAL MODULE: ./src/hooks/useModalContext.tsx
var useModalContext = __webpack_require__(67379);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
;// CONCATENATED MODULE: ./src/components/steelbuildingestimates/logo/index.tsx

function SteelBuildingEstimatesLogo() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "407",
        height: "35",
        fill: "none",
        viewBox: "0 0 407 35",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_2_2)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#249DD8",
                        d: "M108.34 10.791c0 3.214-1.152 4.86-3.904 5.102v.15c3.455.277 4.606 2.384 4.606 5.954 0 4.607-2.234 5.759-7.578 5.759-4.272 0-6.622 0-9.432-.253V5.24a82.526 82.526 0 018.396-.276c5.873 0 7.912 1.22 7.912 5.827zm-7.843 3.57c2.384 0 3.144-.61 3.144-2.89 0-2.28-.829-2.753-3.455-2.787h-3.329v5.7l3.64-.022zm-3.605 9.744h3.755c2.683 0 3.455-.553 3.455-3.052 0-2.718-.818-3.455-3.594-3.455h-3.639l.023 6.507zM127.423 16.711c0 2.902-1.405 4.457-4.848 4.457h-5.759c.265 2.419 1.336 2.96 3.778 2.96 1.463 0 3.789-.15 5.954-.357l.461 2.96a17.491 17.491 0 01-6.91 1.22c-6.047 0-8.339-2.476-8.339-8.36 0-6.289 2.304-8.431 8.062-8.431 5.459 0 7.544 1.889 7.601 5.551zm-10.71 1.59h4.514c1.279 0 1.498-.76 1.498-1.647 0-1.498-.645-2.016-2.718-2.016-2.407 0-3.179.645-3.294 3.662zM143.939 11.77l-.334 3.052h-6.139c-2.499 0-3.075 0-3.075 1.071 0 1.072.576 1.002 2.096 1.428l4.066 1.152c2.718.726 3.962 1.854 3.962 4.607 0 3.939-2.166 4.883-7.325 4.883a44.146 44.146 0 01-7.141-.553l.277-3.11h5.551c3.271 0 4.008-.149 4.008-1.15 0-1.003-.68-1.072-2.304-1.498l-4.007-1.071c-3.018-.795-3.87-2.304-3.87-4.849 0-3.328 1.831-4.607 6.806-4.55a46.609 46.609 0 017.429.588zM158.231 11.586v3.202h-4.422v7.543c0 1.221.449 1.624 1.739 1.624h2.038l.519 3.352c-1.46.407-2.965.624-4.48.645a4.198 4.198 0 01-3.402-1.205 4.195 4.195 0 01-1.205-3.402v-8.557h-2.81V11.77l2.81-.184V7.083h4.768v4.457l4.445.046z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#F8971D",
                        d: "M184.732 12.231c0 5.758-1.993 7.29-7.509 7.29a37.584 37.584 0 01-4.215-.242v8.27h-4.918V5.24a73.018 73.018 0 018.488-.31c6.161 0 8.154 1.589 8.154 7.301zm-11.724 3.455h3.455c2.499 0 3.294-.737 3.294-3.455s-.795-3.547-3.294-3.455h-3.455v6.91zM203.412 19.59c0 6.127-2.222 8.385-8.177 8.385-5.954 0-8.246-2.304-8.246-8.385 0-6.08 2.304-8.43 8.246-8.43 5.943 0 8.177 2.292 8.177 8.43zm-11.39 0c0 3.812.68 4.791 3.213 4.791 2.534 0 3.167-.979 3.167-4.79 0-3.813-.725-4.86-3.167-4.86-2.441 0-3.213.978-3.213 4.86zM220.089 11.77l-.346 3.052h-6.127c-2.51 0-3.086 0-3.086 1.071 0 1.072.576 1.002 2.107 1.428l4.054 1.152c2.718.726 3.974 1.854 3.974 4.607 0 3.939-2.166 4.883-7.325 4.883a44.056 44.056 0 01-7.141-.553l.265-3.11h5.563c3.259 0 3.996-.149 3.996-1.15 0-1.003-.668-1.072-2.303-1.498l-3.996-1.071c-3.029-.795-3.882-2.304-3.882-4.849 0-3.328 1.832-4.607 6.807-4.55a46.863 46.863 0 017.44.588zM234.37 11.586v3.202h-4.423v7.543c0 1.221.461 1.624 1.739 1.624h2.05l.519 3.352a17.706 17.706 0 01-4.492.645 4.192 4.192 0 01-4.607-4.607v-8.557h-2.798V11.77l2.798-.184V7.083h4.768v4.457l4.446.046zM251.622 16.988v10.56h-3.789l-.484-2.441a7.63 7.63 0 01-5.896 2.845c-2.983 0-5.217-1.624-5.217-4.607V21.72c0-2.568 1.865-4.031 4.883-4.031h5.758v-.726c0-1.623-.587-2.05-2.626-2.05-1.531 0-4.18.093-6.749.242l-.426-3.236a55.656 55.656 0 018.304-.76c4.077 0 6.242 1.347 6.242 5.828zm-9.098 3.57c-1.152 0-1.555.61-1.555 1.532v.61c0 1.152.576 1.647 1.866 1.647a7.163 7.163 0 003.996-1.555v-2.234h-4.307zM266.583 11.586h5.159l-.219 2.108-2.015.276c.285.734.422 1.517.403 2.303 0 3.663-1.9 5.125-7.509 5.125a23.386 23.386 0 01-2.752-.184 1.15 1.15 0 00.921 1.924l5.758.667c3.329.404 4.607 1.9 4.607 4.768 0 4.147-2.303 5.16-8.396 5.16-6.622 0-8.419-1.152-8.419-4.733 0-1.647.703-2.592 2.534-3.455a3.227 3.227 0 01.518-4.918c-1.681-.76-2.303-2.165-2.303-4.307 0-3.72 1.889-5.126 7.532-5.126a16.744 16.744 0 014.181.392zm-6.784 14.972a2.238 2.238 0 00-1.036 1.866c0 1.555.702 1.797 3.789 1.797 3.086 0 3.881-.3 3.881-1.74 0-1.151-.587-1.278-2.626-1.497l-4.008-.426zm-.518-10.25c0 1.555.737 2.073 3.121 2.073s3.052-.518 3.052-2.073-.702-2.05-3.052-2.05c-2.349 0-3.121.415-3.121 2.039v.011zM289.179 16.711c0 2.902-1.405 4.457-4.86 4.457h-5.759c.277 2.419 1.348 2.96 3.789 2.96 1.463 0 3.789-.15 5.955-.357l.449 2.96a17.491 17.491 0 01-6.91 1.22c-6.047 0-8.327-2.476-8.327-8.36 0-6.289 2.303-8.431 8.062-8.431 5.459 0 7.532 1.889 7.601 5.551zm-10.722 1.59h4.526c1.278 0 1.486-.76 1.486-1.647 0-1.498-.634-2.016-2.707-2.016-2.418 0-3.167.645-3.305 3.662z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#249DD8",
                        d: "M322.141 5.24a1.69 1.69 0 011.771 1.105c.086.236.118.488.094.738l.853 20.477h-4.607l-.76-18.427h-.588l-3.351 13.82a1.866 1.866 0 01-2.016 1.59h-3.236a1.832 1.832 0 01-1.981-1.59l-3.455-13.82h-.553l-.633 18.427h-4.676l.864-20.477a1.643 1.643 0 011.831-1.831h4.756a1.869 1.869 0 011.958 1.59l2.718 11.101a40.43 40.43 0 01.576 3.144h.426c.185-1.036.311-2.072.576-3.144l2.741-11.113a1.855 1.855 0 011.981-1.59h4.711zM343.7 16.711c0 2.902-1.405 4.457-4.848 4.457h-5.759c.277 2.419 1.336 2.96 3.778 2.96 1.474 0 3.789-.15 5.954-.357l.461 2.96a17.496 17.496 0 01-6.911 1.22c-6.046 0-8.338-2.476-8.338-8.36 0-6.289 2.304-8.431 8.12-8.431 5.413 0 7.486 1.889 7.543 5.551zm-10.711 1.59h4.515c1.278 0 1.497-.76 1.497-1.647 0-1.498-.645-2.016-2.718-2.016-2.407 0-3.178.645-3.294 3.662zM357.44 11.586v3.202h-4.423v7.543c0 1.221.461 1.624 1.739 1.624h2.051l.518 3.352a17.706 17.706 0 01-4.492.645 4.194 4.194 0 01-4.607-4.607v-8.557h-2.798V11.77l2.798-.184V7.083h4.768v4.457l4.446.046zM375.153 16.711c0 2.902-1.405 4.457-4.86 4.457h-5.759c.277 2.419 1.348 2.96 3.789 2.96 1.463 0 3.789-.15 5.955-.357l.449 2.96a17.491 17.491 0 01-6.91 1.22c-6.047 0-8.327-2.476-8.327-8.36 0-6.289 2.303-8.431 8.119-8.431 5.425 0 7.475 1.889 7.544 5.551zm-10.722 1.59h4.526c1.278 0 1.486-.76 1.486-1.647 0-1.498-.634-2.016-2.707-2.016-2.418 0-3.179.645-3.305 3.662zM388.006 15.582a16.024 16.024 0 00-4.895 1.152v10.86h-4.791V11.587h3.732l.391 2.303a10.287 10.287 0 016.473-2.775h.852l-.484 4.422-1.278.046zM405.431 11.77l-.334 3.052h-6.138c-2.5 0-3.075 0-3.075 1.071 0 1.072.575 1.002 2.107 1.428l4.054 1.152c2.718.726 3.973 1.854 3.973 4.607 0 3.939-2.165 4.883-7.324 4.883a44.16 44.16 0 01-7.152-.553l.276-3.11h5.563c3.259 0 3.996-.149 3.996-1.15 0-1.003-.668-1.072-2.303-1.498l-4.008-1.071c-3.018-.795-3.87-2.304-3.87-4.849 0-3.328 1.831-4.607 6.807-4.55a46.596 46.596 0 017.428.588zM64.564 33.491H24.888c-.42 0-.76.338-.76.755 0 .416.34.754.76.754h39.676c.42 0 .76-.338.76-.754a.757.757 0 00-.76-.755z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#F8971D",
                        d: "M25.326 12.922H14.258c-.42 0-.76.338-.76.754 0 .417.34.755.76.755h11.068c.42 0 .76-.338.76-.755a.757.757 0 00-.76-.754zM26.27 20.638h-6.806c-.42 0-.76.338-.76.755 0 .416.34.754.76.754h6.806c.42 0 .76-.338.76-.754a.757.757 0 00-.76-.755zM22.17 16.976H.76c-.42 0-.76.338-.76.754 0 .417.34.755.76.755h21.41c.42 0 .76-.338.76-.755a.757.757 0 00-.76-.754z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#249DD8",
                        d: "M55.558 0H23.69c-.42 0-.76.338-.76.754 0 .417.34.755.76.755h31.868c.42 0 .76-.338.76-.755a.757.757 0 00-.76-.754z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#F8971D",
                        d: "M82.657 18.058l-6.115-6.115v2.81H71.75a.323.323 0 00-.311.323v5.954a.313.313 0 00.31.322h4.792v2.81l6.115-6.104z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#249DD8",
                        d: "M67.627 4.4H29.783a.622.622 0 00-.622.621v24.612c0 .344.278.622.622.622h37.844a.622.622 0 00.622-.622V5.021a.622.622 0 00-.621-.622z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M65.497 6.334H31.913a.541.541 0 00-.54.542V27.79c0 .3.241.542.54.542h33.584a.541.541 0 00.541-.542V6.876a.541.541 0 00-.541-.542z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#249DD8",
                        d: "M39.365 8.5h-4.803a.564.564 0 00-.564.564v4.802c0 .312.253.565.564.565h4.803a.564.564 0 00.564-.565V9.064a.564.564 0 00-.564-.564zM45.008 9.548h-2.902a.596.596 0 00-.599.593c0 .327.268.593.599.593h2.902c.331 0 .6-.266.6-.593a.596.596 0 00-.6-.593zM48.648 11.275h-6.542a.596.596 0 00-.599.593c0 .328.268.593.599.593h6.542c.33 0 .598-.265.598-.593a.596.596 0 00-.598-.593zM53.197 12.991H42.106a.596.596 0 00-.599.593c0 .328.268.593.599.593h11.09c.332 0 .6-.265.6-.593a.596.596 0 00-.6-.593z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_2_2",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H406.018V35H0z"
                    })
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/mobile/index.tsx + 1 modules
var mobile = __webpack_require__(8281);
;// CONCATENATED MODULE: ./src/components/layouts/steelbuildingestimatesWrapper.tsx









const Modal = dynamic_default()(()=>__webpack_require__.e(/* import() */ 84043).then(__webpack_require__.bind(__webpack_require__, 18740)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(18740)
            ]
    }
});
const Footer = dynamic_default()(()=>__webpack_require__.e(/* import() */ 60681).then(__webpack_require__.bind(__webpack_require__, 31701)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(31701)
            ]
    }
});
const CloseIcon = dynamic_default()(()=>__webpack_require__.e(/* import() */ 69655).then(__webpack_require__.bind(__webpack_require__, 69655)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(69655)
            ]
    }
});
const TermsAndConditions = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(10761), __webpack_require__.e(14777)]).then(__webpack_require__.bind(__webpack_require__, 10761)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(10761)
            ]
    }
});
const PrivacyPolicy = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(57079), __webpack_require__.e(25591)]).then(__webpack_require__.bind(__webpack_require__, 57079)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(57079)
            ]
    }
});
function SteelBuildingEstimatesWrapper({ children  }) {
    const { modal , closeModal  } = (0,useModalContext/* useModal */.d)();
    const { visitDetails: { region  } ,  } = (0,useDomainContext/* useDomainContext */.w)();
    const handleClose = ()=>{
        closeModal();
    };
    const { active: modalActive , content: modalContent  } = modal;
    const getModalContent = ()=>{
        switch(modalContent){
            case "privacy":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PrivacyPolicy, {
                    category: "Steel Building",
                    domain: "SteelBuildingEstimates.com"
                });
            case "terms":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsAndConditions, {
                    category: "Steel Building",
                    domain: "SteelBuildingEstimates.com"
                });
            case "sideWidget":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile/* default */.Z, {});
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.googleapis.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.gstatic.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        href: "https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap",
                        rel: "stylesheet"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    fontFamily: `'Poppins', sans-serif`
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header["default"], {
                        textColor: "#0482b0",
                        slogan: `The Best Steel Building Companies ${region ? `in ${region}` : ""}`,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SteelBuildingEstimatesLogo, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                        className: "max-w-7xl mx-auto block px-4vw lg:px-4",
                        children: children
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
                        onClose: handleClose,
                        active: modalActive,
                        closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon, {}),
                        backdropClosable: true,
                        modalStyles: {
                            display: "flex",
                            flexDirection: "column",
                            maxHeight: modalContent === "sideWidget" ? "80vh" : "100%"
                        },
                        modalClassName: "h-[90vh] rounded",
                        bodyStyles: {
                            overflowY: "scroll"
                        },
                        width: 900,
                        header: modalContent === "privacy" ? "Privacy Policy" : modalContent === "terms" ? "Terms and Conditions" : modalContent === "sideWidget" ? "Contents" : undefined,
                        children: getModalContent()
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 74206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88737);
/* harmony import */ var _components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10621);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78418);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19255);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _page_builder_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79961);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75094);








// import CloseIcon from "@components/svg/closeIcon";

function Header({ slogan , children , textColor , iconColor , backGroundColor , isLogoClickable =true , emptyIcon , boxShadow , border , phoneNumberColor , stickyStyle , hideSticky , logoClassName , useChildrenLogo , bannerStyleAsProp , className , useSecondaryLogo =false  }) {
    const { domain , blogPost , routeConfig , showFormModal , locale , defaultLocale , pageType ,  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__/* .useDomainContext */ .w)();
    const { 0: headerHeight , 1: setHeaderHeight  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const header = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { 0: bannerActive , 1: setBannerActive  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: hidePhoneNumber , 1: setHidePhoneNumber  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { query , asPath  } = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const bannerTextBlock = domain.textBlocks?.find((textBlock)=>textBlock.position === "banner");
    function showingBanner() {
        if (!bannerTextBlock) return false;
        if (pageType === "page-builder") {
            return !routeConfig?.config?.settings?.preHeaderText;
        }
        return true;
    }
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        let prevHeight = "0";
        const observer = new ResizeObserver(([headerEntry])=>{
            if (header.current) {
                const height = headerEntry.borderBoxSize?.[0]?.blockSize.toFixed(0);
                if (height !== prevHeight) {
                    prevHeight = height;
                    setHeaderHeight(`${height}px`);
                }
            }
        });
        if (header.current) {
            observer.observe(header.current);
        }
        if (bannerTextBlock) {
            setTimeout(()=>{
                setBannerActive(true);
            }, 500);
        }
        if (sessionStorage.getItem(_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .SKIPPED_OPERATION_ID_KEY */ .UG) && asPath.includes("thank-you")) {
            setHidePhoneNumber(true);
        }
        return ()=>{
            if (header.current) {
                observer.unobserve(header.current);
            }
        };
    }, []);
    const logoFromVariantConfig = routeConfig?.templateConfig?.variantConfig?.logo;
    const logoPath = logoFromVariantConfig ?? routeConfig?.config?.settings?.logo ?? domain?.logo?.fullPath;
    const secondaryLogoPath = domain?.secondaryLogo?.fullPath ?? null;
    const callIconUnWrappedImage = routeConfig?.templateConfig?.headerAndFooter?.header?.callIconUnWrappedImage;
    const phoneNumberBlock = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "slogan items-center flex",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            slogan: slogan,
            textColor: textColor,
            iconColor: iconColor ?? textColor,
            emptyIcon: emptyIcon,
            phoneNumberColor: phoneNumberColor,
            stickyStyle: stickyStyle,
            hideSticky: hideSticky || showFormModal,
            iconPath: callIconUnWrappedImage
        })
    });
    const finalUrl = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        if (!isLogoClickable) {
            return undefined;
        }
        const homepageHref = (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .getHomepageHref */ .$N)(query, locale, defaultLocale);
        if (homepageHref === undefined) {
            return undefined;
        }
        const withQueryParams = (0,_lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__/* .gettingQueriesAsString */ .r)(query, "start", [
            "genericRoute",
            "keyword",
            "category",
            "formTemplate",
            "tool",
            "slug",
            "data",
            "zc",
            "filters",
            "pii-token", 
        ]);
        return `${homepageHref}?${withQueryParams}`;
    }, [
        isLogoClickable,
        query
    ]);
    const variables = routeConfig?.config?.header?.variables;
    const styles = {
        backgroundColor: backGroundColor,
        boxShadow: boxShadow,
        borderBottom: border,
        ...variables ? (0,_page_builder_utils__WEBPACK_IMPORTED_MODULE_7__/* .convertToBreakpointVariables */ .Xz)(variables) : {}
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
        style: styles,
        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().header)} ${className}`,
        ref: header,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `ltrStyle inner py-5 lg:py-4 px-5 flex lg:max-w-7xl mx-auto  lg:px-6 items-center ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().headerContainer)} `,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().logo)} ${logoClassName ? logoClassName : ""}`,
                        style: {
                            backgroundImage: `url(${useSecondaryLogo ? secondaryLogoPath : logoPath ?? ""})`,
                            width: "auto",
                            height: "auto",
                            backgroundSize: "contain",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                            ...domain.name === "homewarranty.deals" ? {
                                maxWidth: "330px"
                            } : {}
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: finalUrl,
                            "aria-label": `${domain.name} logo`,
                            children: logoPath && !useChildrenLogo ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: logoPath,
                                className: "h-auto w-full",
                                alt: `${domain.name} logo`,
                                style: {
                                    visibility: "hidden"
                                },
                                rel: "preload"
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "children:w-full children:h-auto lg:children:h-10",
                                children: children
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            blogPost && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-xs lg:flex hidden justify-end text-[#6b6b6b] ",
                                children: "Advertisement"
                            }),
                            !hidePhoneNumber && phoneNumberBlock
                        ]
                    }),
                    headerHeight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                        children: `:root {--header-height: ${headerHeight} }`
                    })
                ]
            }),
            showingBanner() && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().banner)} ${bannerStyleAsProp ?? ""} ${bannerActive ? (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().active) : ""}`,
                style: {
                    "--banner-background-color": domain?.config?.bannerBgColor,
                    "--banner-text-color": domain?.config?.bannerTextColor
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: bannerTextBlock?.text ?? ""
                    },
                    className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["banner-inner"])
                })
            })
        ]
    });
}


/***/ }),

/***/ 78418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ gettingQueriesAsString; }
/* harmony export */ });
const gettingQueriesAsString = (query, location, excludeList)=>{
    const initialValue = "";
    return Object.keys(query).reduce(function(previousValue, currentValue, index) {
        const value = query[currentValue];
        if (excludeList?.includes(currentValue)) {
            return previousValue;
        }
        return previousValue + `${index !== 0 ? "&" : ""}${currentValue}=${value}`;
    }, initialValue);
};


/***/ }),

/***/ 79961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CA": function() { return /* binding */ extractUrl; },
/* harmony export */   "OZ": function() { return /* binding */ generateGlobalVariables; },
/* harmony export */   "XR": function() { return /* binding */ getFinalFontFamily; },
/* harmony export */   "Xz": function() { return /* binding */ convertToBreakpointVariables; },
/* harmony export */   "Z2": function() { return /* binding */ modifyCSSForElement; },
/* harmony export */   "hJ": function() { return /* binding */ minifyCSS; },
/* harmony export */   "uC": function() { return /* binding */ getFormTemplate; }
/* harmony export */ });
/* unused harmony export breakpoints */
const breakpoints = [
    "sm",
    "md",
    "lg",
    "xl",
    "xxl"
];
// ****** EXAMPLE INPUT ******
// variables = {
//     "titleSize": {
//         "sm": "14px",
//         "md": "16px",
//     },
//     "descriptionSize": "14px",
//     "titleColor": {
//          "sm": "red",
//          "lg": "blue",
//     },
// }
// ****** OUTPUT ******
// breakpointVariables = {
//     "--title-size-sm": "14px",
//     "--title-size-md" : "16px",
//     "--title-size-lg" : "16px",
//     "--title-size-xl" : "16px",
//     "--title-size-xxl" : "16px",
//     "--description-size-sm": "14px",
//     "--description-size-md": "14px",
//     "--description-size-lg": "14px",
//     "--description-size-xl": "14px",
//     "--description-size-xxl": "14px",
//     "--title-color-sm": "red",
//     "--title-color-md": "red",
//     "--title-color-lg": "blue",
//     "--title-color-xl": "blue",
//     "--title-color-xxl": "blue",
// }
/**
 * Convert variables object to css variables with breakpoints handled
 *
 * @param variables - variables object to convert
 * @param namespace - optional namespace to prefix variable names (e.g., "tabs", "accordion")
 */ function convertToBreakpointVariables(variables, namespace) {
    const breakpointVariables = {};
    for (const [key, value] of Object.entries(variables)){
        if (!value) continue;
        // Create variable name with optional namespace prefix
        const varName = namespace ? `${namespace}-${key}` : key;
        if (typeof value === "object") {
            const objValue = value;
            breakpoints.forEach((breakpoint, index)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = objValue[breakpoint] || objValue[breakpoints[index - 1]] || objValue[breakpoints[index - 2]] || objValue[breakpoints[index - 3]] || objValue[breakpoints[index - 4]] || objValue["sm"] || "unset";
            });
        } else {
            breakpoints.forEach((breakpoint)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = value;
            });
        }
    }
    return breakpointVariables;
}
function generateGlobalVariables(config) {
    const cssVariables = {};
    function recursiveGenerateCSSVariables(obj, prefix = "") {
        for(const key in obj){
            if (key in obj) {
                const value = obj[key];
                if (typeof value !== "string" && value !== null) {
                    recursiveGenerateCSSVariables(value, `${prefix}-${key}`);
                } else {
                    const variableName = `--${prefix}-${key.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()}`;
                    cssVariables[variableName] = value || "unset";
                }
            }
        }
    }
    recursiveGenerateCSSVariables(config, "global");
    return cssVariables;
}
const minifyCSS = (css)=>css.replace(/\n/g, "").replace(/\s\s+/g, " ");
function modifyCSSForElement(cssString, selector) {
    if (!cssString) return "";
    // At-rules that should have selector prepended to their inner rules
    const scopedAtRules = [
        "@media",
        "@supports",
        "@container",
        "@layer"
    ];
    // At-rules that should be kept as-is (no selector modification)
    const globalAtRules = [
        "@keyframes",
        "@-webkit-keyframes",
        "@-moz-keyframes",
        "@font-face",
        "@import",
        "@charset",
        "@namespace",
        "@page", 
    ];
    // Helper to prepend selector to simple CSS rules
    const prependSelectorToRules = (css)=>{
        const rules = css.split("}");
        return rules.map((rule)=>{
            const trimmed = rule.trim();
            if (trimmed === "") return "";
            const braceIndex = trimmed.indexOf("{");
            if (braceIndex === -1) return `${selector} ${trimmed}`;
            const selectorPart = trimmed.substring(0, braceIndex);
            const bodyPart = trimmed.substring(braceIndex);
            const scopedSelectors = selectorPart.split(",").map((s)=>`${selector} ${s.trim()}`).join(", ");
            return `${scopedSelectors} ${bodyPart}`;
        }).join("\n}\n");
    };
    // Find the closing brace that matches an opening brace (handles nesting)
    const findMatchingBrace = (str, startPos)=>{
        let braceCount = 1;
        let pos = startPos;
        while(braceCount > 0 && pos < str.length){
            if (str[pos] === "{") braceCount++;
            if (str[pos] === "}") braceCount--;
            pos++;
        }
        return pos;
    };
    // Find the next at-rule in the string
    const findNextAtRule = (str)=>{
        const allAtRules = [
            ...scopedAtRules,
            ...globalAtRules
        ];
        let earliest = null;
        for (const atRule of allAtRules){
            const index = str.indexOf(atRule);
            if (index !== -1 && (earliest === null || index < earliest.index)) {
                earliest = {
                    index,
                    type: atRule,
                    isScoped: scopedAtRules.includes(atRule)
                };
            }
        }
        return earliest;
    };
    // Recursively process CSS (handles nested at-rules)
    const processCSS = (css)=>{
        let result = "";
        let remaining = css;
        while(remaining.length > 0){
            const nextAtRule = findNextAtRule(remaining);
            if (!nextAtRule) {
                // No more at-rules, process remaining as regular rules
                result += prependSelectorToRules(remaining);
                break;
            }
            // Process any rules before this at-rule
            if (nextAtRule.index > 0) {
                const beforeAtRule = remaining.substring(0, nextAtRule.index);
                result += prependSelectorToRules(beforeAtRule);
            }
            // Find the opening brace for this at-rule
            const openBrace = remaining.indexOf("{", nextAtRule.index);
            if (openBrace === -1) {
                // No brace found (e.g., @import or @charset statement)
                const semicolon = remaining.indexOf(";", nextAtRule.index);
                if (semicolon !== -1) {
                    result += remaining.substring(nextAtRule.index, semicolon + 1);
                    remaining = remaining.substring(semicolon + 1);
                    continue;
                }
                break;
            }
            const atRuleHeader = remaining.substring(nextAtRule.index, openBrace).trim();
            const closeBrace = findMatchingBrace(remaining, openBrace + 1);
            const atRuleContent = remaining.substring(openBrace + 1, closeBrace - 1);
            if (nextAtRule.isScoped) {
                // Scoped at-rules: process inner content recursively
                const processedContent = processCSS(atRuleContent);
                result += `\n${atRuleHeader} {\n${processedContent}\n}\n`;
            } else {
                // Global at-rules: keep content as-is
                result += `\n${atRuleHeader} {\n${atRuleContent}\n}\n`;
            }
            remaining = remaining.substring(closeBrace);
        }
        return result;
    };
    return minifyCSS(processCSS(cssString));
}
const extractUrl = (input)=>{
    const match = input.match(/^url\((.+)\)$/);
    return match ? match[1] : "";
};
const getFormTemplate = (path)=>{
    if (path.includes("/free-consultation/v1")) {
        return "v1";
    }
    if (path.includes("/free-consultation/v2")) {
        return "v2";
    }
    return null;
};
const getFinalFontFamily = (routeConfig, locale, fontFamily)=>{
    const templateGlobalConfig = routeConfig?.templateConfig;
    const fontFamilyFromOtherLanguages = templateGlobalConfig?.variantConfig?.otherLanguagesConfig?.[locale]?.fontFamily;
    const fontFamilyFromMainLanguage = templateGlobalConfig?.theme?.fontFamily?.replace(" ", "");
    if (templateGlobalConfig) {
        return fontFamilyFromOtherLanguages || fontFamilyFromMainLanguage || (locale === "ar" ? "Almarai" : "Poppins");
    } else {
        return fontFamily || (locale === "ar" ? "Almarai" : "Poppins");
    }
};


/***/ }),

/***/ 19255:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__NnJo8","headerContainer":"style_headerContainer__bfY8J","logo":"style_logo__oPgVZ","banner":"style_banner__nKv8j","close-button":"style_close-button__1RZQB","active":"style_active__DfBCW","banner-inner":"style_banner-inner__pvqcg","preHeader":"style_preHeader__0jNK7"};

/***/ })

}]);